import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { alpha, styled } from '@mui/material/styles'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

const Face = styled('div')(({ theme }) => ({
  width: '300px',
  height: '300px',
  border: '4px solid #383A41',
  borderRadius: '10px',
  backgroundColor: '#FFFFFF',
  margin: '0 auto',
  marginTop: '100px',
  boxSizing: 'content-box',
  [theme.breakpoints.down('sm')]: {
    marginTop: '40px',
    transform: 'scale(.8)',
  },
}))

const Band = styled('div')({
  width: '350px',
  height: '27px',
  border: '4px solid #383A41',
  borderRadius: '5px',
  marginLeft: '-25px',
  marginTop: '50px',
  boxSizing: 'content-box',
  position: 'relative',
  '& .red': {
    height: 'calc(100% / 3)',
    width: '100%',
    boxSizing: 'content-box',
    backgroundColor: '#EB6D6D',
  },
  '& .white': {
    height: 'calc(100% / 3)',
    width: '100%',
    boxSizing: 'content-box',
    backgroundColor: '#FFFFFF',
  },
  '& .blue': {
    height: 'calc(100% / 3)',
    width: '100%',
    boxSizing: 'content-box',
    backgroundColor: '#5E7FDC',
  },
  '&:before': {
    content: "''",
    display: 'inline-block',
    height: '27px',
    width: '30px',
    backgroundColor: alpha('#FFFFFF', 0.3),
    boxSizing: 'content-box',
    position: 'absolute',
    zIndex: 999,
  },
  '&:after': {
    content: "''",
    display: 'inline-block',
    height: '27px',
    width: '30px',
    backgroundColor: alpha('#383A41', 0.3),
    boxSizing: 'content-box',
    position: 'absolute',
    zIndex: 999,
    right: 0,
    marginTop: '-27px',
  },
})

const Eyes = styled('div')({
  width: '128px',
  margin: '0 auto',
  marginTop: '40px',
  boxSizing: 'content-box',
  '&:before': {
    content: "''",
    display: 'inline-block',
    width: '30px',
    height: '15px',
    border: '7px solid #383A41',
    marginRight: '20px',
    borderTopLeftRadius: '22px',
    borderTopRightRadius: '22px',
    borderBottom: 0,
    boxSizing: 'content-box',
  },
  '&:after': {
    content: "''",
    display: 'inline-block',
    width: '30px',
    height: '15px',
    border: '7px solid #383A41',
    marginLeft: '20px',
    borderTopLeftRadius: '22px',
    borderTopRightRadius: '22px',
    borderBottom: 0,
    boxSizing: 'content-box',
  },
})

const Dimples = styled('div')({
  width: '180px',
  margin: '0 auto',
  marginTop: '15px',
  boxSizing: 'content-box',
  '&:before': {
    content: "''",
    display: 'inline-block',
    width: '10px',
    height: '10px',
    marginRight: '80px',
    borderRadius: '50%',
    backgroundColor: alpha('#EB6D6D', 0.4),
    boxSizing: 'content-box',
  },
  '&:after': {
    content: "''",
    display: 'inline-block',
    width: '10px',
    height: '10px',
    marginLeft: '80px',
    borderRadius: '50%',
    backgroundColor: alpha('#EB6D6D', 0.4),
    boxSizing: 'content-box',
  },
})

const Mouth = styled('div')({
  width: '40px',
  height: '5px',
  borderRadius: '5px',
  backgroundColor: '#383A41',
  margin: '0 auto',
  marginTop: '25px',
})

export function NotFoundPage() {
  const { t } = useTranslation()

  return (
    <Stack spacing={3} alignItems="center" justifyContent="center" height="100%">
      <Face>
        <Band>
          <div className="red"></div>
          <div className="white"></div>
          <div className="blue"></div>
        </Band>
        <Eyes />
        <Dimples />
        <Mouth />
      </Face>
      <Typography variant="h1" sx={{ fontSize: '32px', fontWeight: 800 }}>
        {t('page.notFound.title')}
      </Typography>
      <Button component={Link} to="/" variant="contained">
        {t('page.notFound.returnToHomeButton.label')}
      </Button>
    </Stack>
  )
}

export default NotFoundPage
